import { IGenericAnalysisAlloc, IPcnAnalysis } from "../../../omnia"
import { IDataLayer, ISoilAnalysisLayerViewerFactory, LayerTypeId } from "../../../types"
import { createMapViewGroup } from "../group"
import { IViewerContext } from "../types"
import { AnalysisView } from "./analysis"

/// <reference path="analysis.ts" />

export function createPcnAnalysisGroup(ctxt: IViewerContext) {

    let { soilSvc, layers, viewManager } = ctxt

    let analysis = soilSvc.getPcnAnalysis();

    layers = layers.filter(l => l.TypeId == LayerTypeId.PcnAnalysis);

    let viewers = viewManager
        .getViewers(LayerTypeId.PcnAnalysis)
        .map(v => new PcnAnalysisView(ctxt, analysis, layers, v));

    viewers = viewers.sort((a, b) => a.key === "CystsPer100Gram" ? -1 : 1);

    return createMapViewGroup("P", "PCN analysis", viewers)

}

export class PcnAnalysisView extends AnalysisView<IPcnAnalysis> {

    constructor(ctxt: IViewerContext, analysis: IPcnAnalysis[], layers: IDataLayer[], layerViewer: ISoilAnalysisLayerViewerFactory) {

        super(ctxt, analysis, LayerTypeId.PcnAnalysis, layers, layerViewer, a => a.FirstYear);

        this.name = "PCN: " + this.name;

    }

    protected getAnalysisId(a: IPcnAnalysis) {
        return a.PcnAnalysisId;
    }

    protected checkZoneAllocation(alloc: IGenericAnalysisAlloc): boolean {
        return !!alloc.ZoneId;
    }

}
